import Network from '@/common/lib/Network';
import Store from '@/config/store';

export default {

  getType() {  

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      fnum_theme: 3
    }

    return Network.execute('GET', 'CWEBS0005A', data);
  },
  getCategory() {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      fnum_theme: 1
    }
  
    return Network.execute('GET', 'CWEBS0005A', data);  
  },
  getMaterial() {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      fnum_theme: 2
    }
    
    return Network.execute('GET', 'CWEBS0005A', data);
  },
  getFonctionnal() {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      fnum_theme: 4
    }
  
    return Network.execute('GET', 'CWEBS0005A', data);
  },
  getEsthetic() {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      fnum_theme: 5
    }
  
    return Network.execute('GET', 'CWEBS0005A', data);
  },
  getOffer() {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      ftyp_cat:"G"
    }
  
    return Network.execute('GET', 'CWEBS0004A', data);
  },
  getColor() {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
    }
  
    return Network.execute('GET', 'CWEBS0006A', data);
  },
  getResearch(query_data) {

    let oBaseParams = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      plimit: query_data.plimit !== undefined ? query_data.plimit : 20,
      poffset: query_data.poffset !== undefined ? query_data.poffset : 0,
    
    };

    const data = {...query_data, ...oBaseParams }

    localStorage.setItem('satabapp-research', JSON.stringify(data));

    return Network.execute('GET', 'CWEBS0003A', data);
  }
}